import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import immutable from 'immutable'

import categoryUtil from '../../util/category.util'

import {Rating} from '../layout/rating.component'
import {LunaModal} from '../lunamodal.component'
import {ActivityEntry} from '../../activities/activityentry.component'


export class RelatedActivity extends React.Component {
    constructor(props) {
        super(props)

        // this._item = new immutable.fromJS(this.props.item)
        this._item = this.props.item

        this.state = {
            isAdded: false,
            showModal: false,
            statusModal: null
        }

        _.bindAll(this,
            'addToItin',
            'removeFromItin',
            'showDetails',
            'showModal',
            'onModalHide',
            'modalContent'
        )
    }

    shouldComponentUpdate(nextProps, nextState) {
        // console.log('update?')
        // console.log(nextProps.leg.get('activities').size + " : " + this.props.leg.get('activities').size)
        if (this.props.className !== nextProps.className || this.props.leg.get('activities').size !== nextProps.leg.get('activities').size || this.state.isAdded !== nextState.isAdded) {
            return true
        } else {
            return false
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let myIndex = this.props.leg.get('activities').findIndex((act) => {
            return act.get('place_id') === this._item.get('place_id')
        })
        if (myIndex > -1) {
            if (!prevState.isAdded) {
                this.setState({isAdded: true})
            }
        } else {
            if (prevState.isAdded) {
                this.setState({isAdded: false})
            }
        }
    }

    addToItin() {
        this.setState({isAdded: true})
        if (this.props.addToItinFromOverview) {
            this.props.addToItinFromOverview(this._item)
        } else {
            this.props.addToItin(this._item) // TODO: Confirm this function passes down correctly, will need to vary by item type
        }
    }

    removeFromItin() {
        this.setState({isAdded: false})
        this.props.removeFromItin(this._item) // TODO: Confirm this function passes down correctly, will need to vary by item type
    }

    showDetails(activity) {
        if (this.props.leg.getIn(['destination', 'id']) === -1 && this.props.onActivateActivityInOverview) {
            this.props.onActivateActivityInOverview(activity)
        } else {
            this.props.onActivateActivity(activity)
            this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACTIVITIES, this.props.availableDetailSubSections.DETAILS)
        }
    }

    showModal(evt) {
        this.setState({
            showModal: true,
            statusModal: null
        })
    }

    onModalHide() {
        this.setState({
            showModal: false
        })
    }

    modalContent() {
        return (
            <div className="modal-content">
                <i className="icon-close" onClick={this.onModalHide}/>
                <ActivityEntry {...this.props} item={this._item} onModalHide={this.onModalHide} isModal={true}/>
            </div>
        )
    }

    render() {
        let addIcon = this.state.isAdded
            ? <i onClick={() => { this.removeFromItin() }} className="related-content-add icon-favorite_selected"/>
            : <i onClick={() => { this.addToItin() }} className="related-content-add icon-favorite"/>
        let showClass = 'related-content-item activity'
        let resIcon = this.state.isAdded ? <div onClick={() => {
            this.showModal()
        }} className="related-content-reservation"><span>RESERVE</span><i className="icon-reservation"/></div> : ''

        if (this.props.className) {
            showClass = this.props.className + ' related-content-item activity'
        } else {
            showClass = this.props.showMe ? 'related-content-item activity' : 'hide related-content-item activity'
        }

        return (
            <div className={showClass}>
                <LunaModal statusModal={this.state.statusModal} onModalHide={this.onModalHide} showModal={this.state.showModal} modalContent={this.modalContent()}/>
                <div className="related-content-header">
                    <h3 onClick={() => {
                        this.showDetails(this._item)
                    }}>{this._item.get('name')}</h3>
                    {addIcon}
                </div>
                <div className="related-content-details">
                    <div className="related-content-category">
                        {categoryUtil.getIconAndLabel(this._item)}
                    </div>
                    <Rating type="cost" itemCount={this._item.get('price')}/>
                </div>
                {resIcon}
            </div>
        )
    }
}
